import { makeAutoObservable } from "mobx"
import { formatCentsAsUsd } from "../util/money"

export default class Package {
  id?: number
  name: string
  price: number
  position: number
  visibleToPassengers: boolean
  url?: string

  constructor(props: any) {
    makeAutoObservable(this, {}, { autoBind: true })

    this.id = props.id
    this.name = props.name
    this.price = props.price
    this.position = props.position
    this.visibleToPassengers = props.visibleToPassengers
    this.url = props.url
  }

  get formattedPrice(): string | undefined {
    return this.price ? formatCentsAsUsd(this.price) : undefined
  }
}
